module.exports = __webpack_public_path__ + "img/traffic-light-red.e43d43e5.svg";